const UserMenu: React.FC = () => {
  return null;
};

export default UserMenu;
